import {LEFT, RIGHT} from 'components/arrangement/constants.js';

class ResizePianoRollPattern {
    constructor(pattern, direction, resizedStep) {
        this.pattern = pattern;
        this.direction = direction;
        this.resizedStep = resizedStep;
    }

    findOverlappingPattern(step=this.resizedStep) {
        return this.pattern.track.patterns
            .filter(p => p !== this.pattern)
            .find(p => p.overlapsStep(step));
    }

    cutOverlappingPattern(pattern, step=this.resizedStep) {
        if (pattern === undefined) {
            return;
        }

        if (this.direction === LEFT) {
            let newLength = step - pattern.startStep;
            if (newLength <= 0) {
                // delete the pattern
                this.deletePattern(pattern);
                return;
            }
            
            pattern.changeLength(newLength);
        } else {
            let stepsToCut = step - pattern.startStep;
            pattern.cutFromStart(stepsToCut);
            pattern.startStep = step;
            if (pattern.length() === 0) {
                this.deletePattern(pattern);
                return;
            }
        }
    }

    deletePattern(pattern) {
        let track = pattern.track;
        track.patterns = track.patterns.filter(
            p => p !== pattern);
    }

    execute() {
        if (this.direction === RIGHT) {
            let newLength = this.resizedStep - this.pattern.startStep

            if (newLength <= 0) {
                return;
            }

            if (newLength > this.pattern.length()) {
                // TODO: transform any patterns that will overlap this one
                // such that they don't overlap (cutting if necessary)
                this.cutOverlappingPattern(this.findOverlappingPattern());
            }
            
            this.pattern.changeLength(newLength, false);
        } else {
            // TODO: We need Pattern.js to include a start and end point that can be shifted
            // here. So that we don't lose data?
            // Instead of mutating the step buckets... Since we can't undo that
            // We could undo if we save a copy of the pattern json before doing this...
            if (this.resizedStep < this.pattern.startStep) {
                // add difference to the beginning of pattern
                // TODO: transform any patterns that will overlap this one
                // such that they don't overlap (cutting if necessary)
                this.cutOverlappingPattern(this.findOverlappingPattern());
                this.pattern.addToStart(this.pattern.startStep - this.resizedStep);
            } else {
                // cut difference many steps from beginning of pattern

                // TODO: make sure theres at least one step... 
                this.pattern.cutFromStart(this.resizedStep - this.pattern.startStep);
                if (this.pattern.length() === 0) {
                    this.deletePattern(this.pattern);
                }
            }
            this.pattern.startStep = this.resizedStep;
        }

        this.pattern.track.updateSteps(true);
    }
}

export default ResizePianoRollPattern;
